var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5C6E7D;stroke-width:1.5;}\n\t.st4{fill:none;stroke:#5C6E7D;stroke-width:1.5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,22.2H9c-3.5,0-5.3-1.9-5.3-5.3V7.6c0-3.5,1.9-5.3,5.3-5.3c1.4,0,2.8,0,4.1,0c1.6,0,2.7,0.5,3.3,0.8 c0.9,0.5,1.4,1,2.1,1.7c0.7,0.7,1.2,1.2,1.7,2.1c0.5,0.9,0.6,1.8,0.6,2.4c0,2.2,0,4.4,0,6.7v1.1C20.9,20.3,18.9,22.2,15.5,22.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,6c2.4,0,4.8-0.1,7.3-0.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,17.2c2.5,0,5.1-0.1,7.6-0.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.6,21.9c0-1.8,0-3.6,0-5.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,21.8c0-1.8,0-3.6,0-5.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.d4877f3505fbfe8ba8d475ac6ec24315.svg";
export { ForwardRef as ReactComponent };